<div class="app-body">
  <main class="main d-flex align-items-center min-vh-100">
    <div class="container">
      <div class="col-md-5 mx-auto">
        <div class="card shadow-lg">
          <div class="card-body p-5">
            <div class="text-center mb-4">
              <img
                src="/assets/img/brand/firm360-logo-v2.png"
                alt="Firm360 Logo"
                class="logo"
              />
            </div>

            @if (authenticationError) {
              <div class="alert alert-danger" data-qaa="failedSignInError">
                <strong>Failed to sign in!</strong><br />
                {{
                  errorMessage || "Please check your credentials and try again."
                }}
              </div>
            }
            @if (source) {
              <div class="alert alert-success" data-qaa="successActivation">
                @if (source === "activate") {
                  <p>
                    <strong>Success!</strong> Your user is now active. You may
                    now login.
                  </p>
                }
                @if (source === "reset") {
                  <p data-qaa="changedPasswordSuccess">
                    <strong>Success!</strong> You have changed your password.
                    You may now login.
                  </p>
                }
                @if (source === "activate") {
                  <p class="mb-0">
                    Tip: After login, go ahead and bookmark the homepage for
                    easy access in the future
                  </p>
                }
              </div>
            }

            <form [formGroup]="loginForm" (ngSubmit)="login()" class="form">
              <div class="form-floating">
                <input
                  #usernameField
                  formControlName="username"
                  class="form-control mb-0"
                  id="username"
                  placeholder="Email"
                  type="email"
                  data-qaa="usernameLogin"
                />
                <label for="username">Email Address</label>
              </div>

              <div class="h-30">
                @if (
                  f.username.errors?.required && submitted && f.username.invalid
                ) {
                  <p class="text-danger" data-qaa="requiredUsernameError">
                    <small>This field is required.</small>
                  </p>
                }
                @if (
                  f.username.errors?.email && submitted && f.username.invalid
                ) {
                  <p class="text-danger" data-qaa="invalidEmailError">
                    <small>Please enter a valid email.</small>
                  </p>
                }
              </div>
              <div class="form-floating">
                <input
                  formControlName="password"
                  class="form-control mb-0"
                  id="password"
                  placeholder="Password"
                  type="password"
                  data-qaa="passwordLogin"
                />
                <label for="password">Password</label>
              </div>
              <div class="h-30">
                @if (
                  f.password.errors?.required && submitted && f.password.invalid
                ) {
                  <p class="text-danger" data-qaa="requiredPasswordError">
                    <small>This field is required.</small>
                  </p>
                }
              </div>
              <button
                [disabled]="saving"
                class="btn btn-sign-up w-100"
                type="submit"
                data-qaa="signInButton"
              >
                Sign in
                @if (saving) {
                  <span class="spinner-border spinner-border-sm ms-2"></span>
                }
              </button>
              <div class="text-center mt-3">
                <a routerLink="/reset/request" class="link">Forgot Password?</a>
              </div>
            </form>

            <!-- OAuth Login -->
            @if (oauthEnabled) {
              <div class="mt-4">
                <div class="divider d-flex align-items-center my-3">
                  <span class="text-muted px-3">or</span>
                </div>
                <button
                  type="button"
                  class="btn btn-outline-secondary w-100 d-flex align-items-center justify-content-center gap-2"
                  (click)="loginWithMicrosoft()"
                  [disabled]="oauthLoading"
                  data-qaa="microsoftSignInButton"
                >
                  @if (!oauthLoading) {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                    >
                      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
                    </svg>
                  }
                  @if (oauthLoading) {
                    <span class="spinner-border spinner-border-sm"></span>
                  }
                  Sign in with Microsoft
                </button>
              </div>
            }

            <div class="text-center mt-4">
              <small class="text-muted d-block">
                By logging in and using Firm360, you agree to the
              </small>
              <small class="text-muted d-block mt-2">
                <a
                  class="link bold"
                  href="https://www.myfirm360.com/terms-of-use/"
                  >Terms</a
                >
                and
                <a
                  class="link bold"
                  href="https://www.myfirm360.com/privacy-policy/"
                  >Privacy Policy</a
                >
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
